// Google Analytics event tracking

const getAdminStatus = (): boolean => {
  try {
    // Extract token from cookies
    const cookies = document.cookie.split('; ');
    let token = '';
    for (const cookie of cookies) {
      const [name, value] = cookie.split('=');
      if (name === 'access_token') {
        token = value;
        break;
      }
    }

    if (!token) {
      return false;
    }

    // Decode JWT
    const payload = token.split('.')[1];
    if (!payload) {
      return false;
    }

    // Decode payload
    const decoded = JSON.parse(atob(payload));
    return decoded.is_admin === true;
  } catch {
    return false;
  }
};

const trackEvent = (eventName: string, eventData: any = {}) => {
  try {
    // Skip tracking for admin accounts
    if (getAdminStatus()) {
      return;
    }

    // Skip tracking for localhost
    if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
      return;
    }

    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', eventName, eventData);
    }
  } catch (error) {
    // silently fail
  }
};

export const trackAnalyticsSelection = (name: string, isSelected: boolean, isMultiselect?: boolean) => {
  trackEvent('analytics_selected', {
    analytics_name: name,
    action: isSelected ? 'select' : 'deselect',
    is_multiselect: !!isMultiselect,
  });
};

export const trackVisualizationCreated = (type: string) => {
  trackEvent('visualization_created', { visualization_type: type });
};

export const trackVisualizationRemoved = (type: string) => {
  trackEvent('visualization_removed', { visualization_type: type });
};

export const trackDateFilterChanged = (filterType: string, filterValue: string) => {
  trackEvent('date_filter_changed', {
    filter_type: filterType,
    filter_value: filterValue,
  });
};

export const trackViewLoaded = (viewName: string, viewType: string) => {
  trackEvent('view_loaded', {
    view_name: viewName,
    view_type: viewType,
  });
};

export const trackDashboardEnter = () => {
  trackEvent('dashboard_entered');
};
